export function CanvasPrintStyles() {
  return (
    <style>{`
      @media print {
        body * {
          visibility: hidden !important;
        }
        .roros-canvas-print-area,
        .roros-canvas-print-area * {
          visibility: visible !important;
        }
        .roros-canvas-print-area {
          position: absolute !important;
          inset: 0 auto auto 0 !important;
          width: 100% !important;
          background: white !important;
          color: #111827 !important;
          box-shadow: none !important;
        }
        .roros-canvas-no-print,
        nav,
        aside,
        header {
          display: none !important;
        }
        main {
          overflow: visible !important;
        }
        .roros-canvas-print-area .shadow,
        .roros-canvas-print-area [class*="shadow"] {
          box-shadow: none !important;
        }
      }
    `}</style>
  );
}
